import { useContext } from 'react'
import { ActiveChatContext } from './ActiveChatContextDef'
import type { ActiveChatContextValue } from './ActiveChatContextDef'

export function useActiveChatContext(): ActiveChatContextValue {
  const ctx = useContext(ActiveChatContext)
  if (!ctx) {
    throw new Error('useActiveChatContext must be used within ActiveChatProvider')
  }
  return ctx
}
